module.exports = __webpack_public_path__ + "static/media/Podcast.8dad3802.png";